





















































import { Vue, Component, Prop } from "vue-property-decorator";
import VCard from "@/components/VCard.vue";
import formatNumber from "@/filters/FormatNumber";
import VAccordion from "@/components/VAccordion.vue";

export type PopulationScalarItem = {
  type: "scalar";
  value: string | number | null;
};
export type PopulationPairItem = {
  type: "pair";
  key: string;
  value: string | number | null;
};
export type PopulationItem = PopulationScalarItem | PopulationPairItem;

export type PopulationGroup = {
  title: string;
  items: PopulationItem[];
};

@Component({ components: { VCard, VAccordion }, filters: { formatNumber } })
export default class PopulationCard extends Vue {
  @Prop({ default: () => "Analisi" }) readonly subject!: string;
  @Prop({ default: 0 }) readonly population!: number;
  @Prop({ default: 0 }) readonly families!: number;
  @Prop({ default: () => [] }) readonly groups!: PopulationGroup[];

  isPair(item: PopulationItem) {
    return item.type === "pair";
  }

  isNumeric(item: PopulationItem) {
    if (item.value === null) {
      return false;
    }
    return !isNaN(+item.value);
  }
}
